module.exports = __webpack_public_path__ + "imgs/adilas.682be32e21ca0e49c855fc40430d5c80.jpg";